import { render, staticRenderFns } from "./Oracle.vue?vue&type=template&id=f0717d3e&scoped=true&"
import script from "./Oracle.vue?vue&type=script&lang=js&"
export * from "./Oracle.vue?vue&type=script&lang=js&"
import style0 from "./Oracle.vue?vue&type=style&index=0&id=f0717d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0717d3e",
  null
  
)

export default component.exports